export const messages = {
  en: {
    simplifyAcceptance: {
      houseNumber: 'House Number',
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      ownerIdCard: 'Owner ID Card',
      licensePlate: 'License Plate',
      memberName: 'Member Name',
      memberPhone: 'Member Phone',
      memberIdCard: 'Member ID Card',
      shopNumber: 'Shop Number',
      contractNumber: 'Contract Number',
      search: 'Search',
      selectHouse: 'Select House',
      moreOperations: 'More Operations',
      handover: 'Handover',
      exitRoom: 'Exit Room',
      ownerId: 'Owner ID:',
      ownerNameLabel: 'Owner Name:',
      contactPhone: 'Contact Phone:',
      idCard: 'ID Card:',
      checkInDate: 'Check-in Date:',
      gender: 'Gender:',
      male: 'Male',
      female: 'Female',
      ownerRemark: 'Owner Remark:',
      houseNumberLabel: 'House Number:',
      shopNumberLabel: 'Shop Number:',
      houseArea: 'House Area:',
      houseType: 'House Type:',
      layout: 'Layout:',
      houseStatus: 'House Status:',
      indoorArea: 'Indoor Area:',
      rent: 'Rent:',
      houseRemark: 'House Remark:',
      accountBalance: 'Account Balance:',
      preDeposit: 'Pre-deposit',
      depositAmount: 'Deposit Amount:',
      refundDeposit: 'Refund Deposit',
      inputSearchCondition: 'Please enter search condition',
      selectHouseFirst: 'Please select a house first',
      houseNumberPlaceholder: 'Please enter house number like 1-1-1',
      ownerNamePlaceholder: 'Please enter owner name',
      ownerPhonePlaceholder: 'Please enter owner phone',
      ownerIdCardPlaceholder: 'Please enter owner ID card',
      licensePlatePlaceholder: 'Please enter license plate',
      memberNamePlaceholder: 'Please enter member name',
      memberPhonePlaceholder: 'Please enter member phone',
      memberIdCardPlaceholder: 'Please enter member ID card',
      shopNumberPlaceholder: 'Please enter shop number like 1-1',
      contractNumberPlaceholder: 'Please enter contract number',
      houseFee: 'House Fee',
      parkingFee: 'Parking Fee',
      paymentHistory: 'Payment History',
      house: 'House',
      shopFee: 'Shop Fee',
      ownerShops: 'Owner Shops',
      contract: 'Contract',
      familyMember: 'Family Member',
      vehicle: 'Vehicle',
      paymentReminder: 'Payment Reminder',
      ownerFeedback: 'Owner Feedback',
      repairOrder: 'Repair Order',
      complaintOrder: 'Complaint Order',
      ownerSync: 'Owner Sync',
      vehicleSync: 'Vehicle Sync',
      reprintReceipt: 'Reprint Receipt',
      historyOwner: 'History Owner',
      meterReadingRecord: 'Meter Reading Record'
    },
    simplifyOwnerShops: {
      shopCode: 'Shop Code',
      location: 'Location',
      area: 'Area',
      validity: 'Validity',
      shopStatus: 'Shop Status',
      shopOweFee: 'Shop Owe Fee',
      operation: 'Operation',
      choose: 'Choose',
      currentShop: 'Current',
      subtotalOweFee: 'Subtotal Owe Fee'
    },
    simplifyOwnerShopFee: {
      selectShop: 'Select Shop',
      selectFeeType: 'Select Fee Type',
      selectFeeItem: 'Select Fee Item',
      selectStatus: 'Select Status',
      valid: 'Valid',
      feeEnd: 'Fee End',
      batchPayment: 'Batch Payment',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      chargeYearMonth: 'Charge Year Month',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      payment: 'Payment',
      paymentHistory: 'Payment History',
      note1: 'Note: End time "-" means not yet due or fee collection has ended',
      note2: 'Note: Receivable amount -1 generally indicates formula error, please check',
      arrearsSubtotal: 'Arrears Subtotal'
    },
    finishFee: {
      confirmOperation: 'Please confirm your operation',
      confirmFinishFee: 'Confirm to finish the fee? Once finished, it cannot be re-enabled. Please operate carefully!',
      cancel: 'Cancel',
      confirm: 'Confirm',
      successMessage: 'Fee finished successfully',
      errorMessage: 'Failed to finish fee'
    },
    simplifyCarFee: {
      selectStatus: 'Select status',
      valid: 'Valid',
      feeEnd: 'Fee End',
      buyMonthCard: 'Buy Month Card',
      batchPay: 'Batch Payment',
      prePay: 'Prepayment',
      tempFee: 'Temporary Fee',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      receivablePeriod: 'Receivable Period',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      pay: 'Pay',
      payHistory: 'Payment History',
      more: 'More',
      cancelFee: 'Cancel Fee',
      feeChange: 'Fee Change',
      splitFee: 'Split Fee',
      detail: 'Detail',
      note1: 'Note: End time "-" means not yet due or fee collection has ended',
      note2: 'Note: Receivable amount -1 generally indicates formula error, please check',
      oweSubtotal: 'Owe Subtotal'
    },
    simplifyContract: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      operation: 'Operation',
      fee: 'Fee',
      view: 'View',
      print: 'Print',
      draftContract: 'Draft Contract'
    },
    simplifyOwnerMember: {
      addMember: 'Add Member',
      memberId: 'Member ID',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      type: 'Type',
      idCard: 'ID Card',
      contact: 'Contact',
      creator: 'Creator',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    simplifyOwnerCar: {
      addCar: 'Add Vehicle',
      plateNumber: 'Plate Number',
      carBrand: 'Car Brand',
      carType: 'Car Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      operation: 'Operation',
      releaseSpace: 'Release Space',
      renewSpace: 'Renew Space',
      edit: 'Edit',
      delete: 'Delete',
      parkingLot: 'Parking Lot',
      space: 'Space',
      none: 'None'
    },
    simplifyOwnerRepair: {
      phoneRepair: 'Phone Repair',
      workOrderCode: 'Work Order Code',
      location: 'Location',
      repairType: 'Repair Type',
      reporter: 'Reporter',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      operation: 'Operation',
      details: 'Details'
    },
    simplifyOwnerComplaint: {
      complaint: 'Complaint',
      complaintType: 'Complaint Type',
      house: 'House',
      building: 'Building',
      unit: 'Unit',
      room: 'Room',
      complainant: 'Complainant',
      complainantPhone: 'Complainant Phone',
      complaintStatus: 'Complaint Status',
      handler: 'Handler',
      handlerPhone: 'Handler Phone',
      operation: 'Operation',
      details: 'Details',
      flowChart: 'Flow Chart',
      none: 'None'
    },
    simplifyOwnerAccessContol: {
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      remark: 'Remark',
      syncTime: 'Sync Time',
      operation: 'Operation',
      resync: 'Resync'
    },
    simplifyOwnerTransactionCar: {
      syncId: 'Sync ID',
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      remark: 'Remark',
      syncTime: 'Sync Time',
      operation: 'Operation',
      resync: 'Resync'
    },
    simplifyShopsHireLog: {
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      operation: 'Operation',
      viewFee: 'View Fee'
    }
  },
  zh: {
    simplifyAcceptance: {
      houseNumber: '房屋号',
      ownerName: '业主姓名',
      ownerPhone: '业主电话',
      ownerIdCard: '业主身份证',
      licensePlate: '车牌号',
      memberName: '成员姓名',
      memberPhone: '成员手机号',
      memberIdCard: '成员身份证',
      shopNumber: '商铺号',
      contractNumber: '合同号',
      search: '查询',
      selectHouse: '选择房屋',
      moreOperations: '更多操作',
      handover: '交房',
      exitRoom: '退房',
      ownerId: '业主编号：',
      ownerNameLabel: '业主名称：',
      contactPhone: '联系电话：',
      idCard: '身份证：',
      checkInDate: '入住日期：',
      gender: '性别：',
      male: '男',
      female: '女',
      ownerRemark: '业主备注：',
      houseNumberLabel: '房屋编号：',
      shopNumberLabel: '商铺编号：',
      houseArea: '房屋面积：',
      houseType: '房屋类型：',
      layout: '户型：',
      houseStatus: '房屋状态：',
      indoorArea: '室内面积：',
      rent: '租金：',
      houseRemark: '房屋备注：',
      accountBalance: '账户余额：',
      preDeposit: '预存',
      depositAmount: '押金金额：',
      refundDeposit: '退押金',
      inputSearchCondition: '请输入查询条件',
      selectHouseFirst: '请先选择房屋',
      houseNumberPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      ownerNamePlaceholder: '请输入业主名称',
      ownerPhonePlaceholder: '请输入业主手机号',
      ownerIdCardPlaceholder: '请输入业主身份证',
      licensePlatePlaceholder: '请输入业主车牌号',
      memberNamePlaceholder: '请输入家庭成员名称',
      memberPhonePlaceholder: '请输入家庭成员电话',
      memberIdCardPlaceholder: '请输入家庭成员身份证',
      shopNumberPlaceholder: '请输入商铺编号 楼栋-商铺 如1-1',
      contractNumberPlaceholder: '请输入合同号',
      houseFee: '房屋费用',
      parkingFee: '停车费用',
      paymentHistory: '缴费历史',
      house: '房屋',
      shopFee: '商铺费用',
      ownerShops: '业主商铺',
      contract: '合同',
      familyMember: '家庭成员',
      vehicle: '车辆',
      paymentReminder: '催缴',
      ownerFeedback: '业主反馈',
      repairOrder: '报修单',
      complaintOrder: '投诉单',
      ownerSync: '业主同步',
      vehicleSync: '车辆同步',
      reprintReceipt: '补打收据',
      historyOwner: '历史业主',
      meterReadingRecord: '抄表记录'
    },
    simplifyOwnerShops: {
      shopCode: '商铺编号',
      location: '位置',
      area: '面积',
      validity: '有效期',
      shopStatus: '商铺状态',
      shopOweFee: '商铺欠费',
      operation: '操作',
      choose: '选择',
      currentShop: '当前',
      subtotalOweFee: '欠费合计'
    },
    simplifyOwnerShopFee: {
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择费用项',
      selectStatus: '请选择状态',
      valid: '有效',
      feeEnd: '收费结束',
      batchPayment: '批量缴费',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      chargeYearMonth: '收费月份',
      receivablePeriod: '应收时间段',
      description: '说明',
      remark: '备注',
      status: '状态',
      operation: '操作',
      payment: '缴费',
      paymentHistory: '缴费历史',
      moreOperations: '更多操作',
      cancelFee: '取消费用',
      feeChange: '费用变更',
      splitFee: '拆费',
      details: '详情',
      note1: '注意：应收结束时间 "-" 表示未到应收时间或收费已结束',
      note2: '注意：应收金额为-1一般为费用项公式设置出错请检查',
      arrearsSubtotal: '欠费小计'
    },
    finishFee: {
      confirmOperation: '请确认您的操作',
      confirmFinishFee: '确定结束费用？结束后无法重新启用，请谨慎操作！',
      cancel: '点错了',
      confirm: '结束费用',
      successMessage: '结束费用成功',
      errorMessage: '结束费用失败'
    },
    simplifyCarFee: {
      selectStatus: '请选择状态',
      valid: '有效',
      feeEnd: '收费结束',
      buyMonthCard: '买月卡',
      batchPay: '批量缴费',
      prePay: '预付收款',
      tempFee: '临时收费',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      receivablePeriod: '应收时间段',
      remark: '说明',
      status: '状态',
      operation: '操作',
      pay: '缴费',
      payHistory: '缴费历史',
      more: '更多操作',
      cancelFee: '取消费用',
      feeChange: '费用变更',
      splitFee: '拆费',
      detail: '详情',
      note1: '注意： 应收结束时间 "-" 表示未到应收时间 或 收费已结束',
      note2: '注意： 应收金额 为-1 一般为费用项公式设置出错请检查',
      oweSubtotal: '欠费小计'
    },
    simplifyContract: {
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      startTime: '开始时间',
      endTime: '结束时间',
      status: '状态',
      operation: '操作',
      fee: '费用',
      view: '查看',
      print: '打印',
      draftContract: '起草合同'
    },
    simplifyOwnerMember: {
      addMember: '添加成员',
      memberId: '成员ID',
      name: '名称',
      gender: '性别',
      male: '男',
      female: '女',
      type: '类型',
      idCard: '身份证',
      contact: '联系方式',
      creator: '创建员工',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    simplifyOwnerCar: {
      addCar: '添加车辆',
      plateNumber: '车牌号',
      carBrand: '车辆品牌',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      startTime: '起租时间',
      endTime: '截止时间',
      status: '状态',
      operation: '操作',
      releaseSpace: '释放车位',
      renewSpace: '续租车位',
      edit: '修改',
      delete: '删除',
      parkingLot: '车场',
      space: '车位',
      none: '无'
    },
    simplifyOwnerRepair: {
      phoneRepair: '电话报修',
      workOrderCode: '工单编码',
      location: '位置',
      repairType: '报修类型',
      reporter: '报修人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      status: '状态',
      operation: '操作',
      details: '详情'
    },
    simplifyOwnerComplaint: {
      complaint: '投诉',
      complaintType: '投诉类型',
      house: '房屋',
      building: '号楼',
      unit: '单元',
      room: '室',
      complainant: '投诉人',
      complainantPhone: '投诉人电话',
      complaintStatus: '投诉状态',
      handler: '处理人',
      handlerPhone: '处理电话',
      operation: '操作',
      details: '详情',
      flowChart: '流程图',
      none: '无'
    },
    simplifyOwnerAccessContol: {
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      remark: '说明',
      syncTime: '同步时间',
      operation: '操作',
      resync: '重新同步'
    },
    simplifyOwnerTransactionCar: {
      syncId: '同步ID',
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      remark: '说明',
      syncTime: '同步时间',
      operation: '操作',
      resync: '重新同步'
    },
    simplifyShopsHireLog: {
      ownerName: '业主名称',
      ownerPhone: '业主电话',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      operation: '操作',
      viewFee: '查看费用'
    }
  },
  'zh-TW': {
    simplifyAcceptance: {
      houseNumber: '房屋號',
      ownerName: '業主姓名',
      ownerPhone: '業主電話',
      ownerIdCard: '業主身份證',
      licensePlate: '車牌號',
      memberName: '成員姓名',
      memberPhone: '成員手機號',
      memberIdCard: '成員身份證',
      shopNumber: '商鋪號',
      contractNumber: '合同號',
      search: '查詢',
      selectHouse: '選擇房屋',
      moreOperations: '更多操作',
      handover: '交房',
      exitRoom: '退房',
      ownerId: '業主編號：',
      ownerNameLabel: '業主名稱：',
      contactPhone: '聯繫電話：',
      idCard: '身份證：',
      checkInDate: '入住日期：',
      gender: '性別：',
      male: '男',
      female: '女',
      ownerRemark: '業主備註：',
      houseNumberLabel: '房屋編號：',
      shopNumberLabel: '商鋪編號：',
      houseArea: '房屋面積：',
      houseType: '房屋類型：',
      layout: '戶型：',
      houseStatus: '房屋狀態：',
      indoorArea: '室內面積：',
      rent: '租金：',
      houseRemark: '房屋備註：',
      accountBalance: '賬戶餘額：',
      preDeposit: '預存',
      depositAmount: '押金金額：',
      refundDeposit: '退押金',
      inputSearchCondition: '請輸入查詢條件',
      selectHouseFirst: '請先選擇房屋',
      houseNumberPlaceholder: '請輸入房屋編號 樓棟-單元-房屋 如1-1-1',
      ownerNamePlaceholder: '請輸入業主名稱',
      ownerPhonePlaceholder: '請輸入業主手機號',
      ownerIdCardPlaceholder: '請輸入業主身份證',
      licensePlatePlaceholder: '請輸入業主車牌號',
      memberNamePlaceholder: '請輸入家庭成員名稱',
      memberPhonePlaceholder: '請輸入家庭成員電話',
      memberIdCardPlaceholder: '請輸入家庭成員身份證',
      shopNumberPlaceholder: '請輸入商鋪編號 樓棟-商鋪 如1-1',
      contractNumberPlaceholder: '請輸入合同號',
      houseFee: '房屋費用',
      parkingFee: '停車費用',
      paymentHistory: '繳費歷史',
      house: '房屋',
      shopFee: '商鋪費用',
      ownerShops: '業主商鋪',
      contract: '合同',
      familyMember: '家庭成員',
      vehicle: '車輛',
      paymentReminder: '催繳',
      ownerFeedback: '業主反饋',
      repairOrder: '報修單',
      complaintOrder: '投訴單',
      ownerSync: '業主同步',
      vehicleSync: '車輛同步',
      reprintReceipt: '補打收據',
      historyOwner: '歷史業主',
      meterReadingRecord: '抄表記錄'
    },
    simplifyOwnerShops: {
      shopCode: '商鋪編號',
      location: '位置',
      area: '面積',
      validity: '有效期',
      shopStatus: '商鋪狀態',
      shopOweFee: '商鋪欠費',
      operation: '操作',
      choose: '選擇',
      currentShop: '當前',
      subtotalOweFee: '欠費合計'
    },
    simplifyOwnerShopFee: {
      selectFeeType: '請選擇費用類型',
      selectFeeItem: '請選擇費用項',
      selectStatus: '請選擇狀態',
      valid: '有效',
      feeEnd: '收費結束',
      batchPayment: '批量繳費',
      feeItem: '費用項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      chargeYearMonth: '收費月份',
      receivablePeriod: '應收時間段',
      description: '說明',
      remark: '備註',
      status: '狀態',
      operation: '操作',
      payment: '繳費',
      paymentHistory: '繳費歷史',
      moreOperations: '更多操作',
      cancelFee: '取消費用',
      feeChange: '費用變更',
      splitFee: '拆費',
      details: '詳情',
      note1: '注意：應收結束時間 "-" 表示未到應收時間或收費已結束',
      note2: '注意：應收金額為-1一般為費用項公式設置出錯請檢查',
      arrearsSubtotal: '欠費小計'
    },
    finishFee: {
      confirmOperation: '請確認您的操作',
      confirmFinishFee: '確定結束費用？結束後無法重新啟用，請謹慎操作！',
      cancel: '點錯了',
      confirm: '結束費用',
      successMessage: '結束費用成功',
      errorMessage: '結束費用失敗'
    },
    simplifyCarFee: {
      selectStatus: '請選擇狀態',
      valid: '有效',
      feeEnd: '收費結束',
      buyMonthCard: '買月卡',
      batchPay: '批量繳費',
      prePay: '預付收款',
      tempFee: '臨時收費',
      feeItem: '費用項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      receivablePeriod: '應收時間段',
      remark: '說明',
      status: '狀態',
      operation: '操作',
      pay: '繳費',
      payHistory: '繳費歷史',
      more: '更多操作',
      cancelFee: '取消費用',
      feeChange: '費用變更',
      splitFee: '拆費',
      detail: '詳情',
      note1: '注意： 應收結束時間 "-" 表示未到應收時間 或 收費已結束',
      note2: '注意： 應收金額 為-1 一般為費用項公式設置出錯請檢查',
      oweSubtotal: '欠費小計'
    },
    simplifyContract: {
      contractName: '合同名稱',
      contractCode: '合同編號',
      parentContractCode: '父合同編號',
      contractType: '合同類型',
      startTime: '開始時間',
      endTime: '結束時間',
      status: '狀態',
      operation: '操作',
      fee: '費用',
      view: '查看',
      print: '列印',
      draftContract: '起草合同'
    },
    simplifyOwnerMember: {
      addMember: '添加成員',
      memberId: '成員ID',
      name: '名稱',
      gender: '性別',
      male: '男',
      female: '女',
      type: '類型',
      idCard: '身份證',
      contact: '聯繫方式',
      creator: '創建員工',
      remark: '備註',
      operation: '操作',
      edit: '修改',
      delete: '刪除'
    },
    simplifyOwnerCar: {
      addCar: '添加車輛',
      plateNumber: '車牌號',
      carBrand: '車輛品牌',
      carType: '車輛類型',
      color: '顏色',
      owner: '業主',
      parkingSpace: '車位',
      startTime: '起租時間',
      endTime: '截止時間',
      status: '狀態',
      operation: '操作',
      releaseSpace: '釋放車位',
      renewSpace: '續租車位',
      edit: '修改',
      delete: '刪除',
      parkingLot: '車場',
      space: '車位',
      none: '無'
    },
    simplifyOwnerRepair: {
      phoneRepair: '電話報修',
      workOrderCode: '工單編碼',
      location: '位置',
      repairType: '報修類型',
      reporter: '報修人',
      contact: '聯繫方式',
      appointmentTime: '預約時間',
      status: '狀態',
      operation: '操作',
      details: '詳情'
    },
    simplifyOwnerComplaint: {
      complaint: '投訴',
      complaintType: '投訴類型',
      house: '房屋',
      building: '號樓',
      unit: '單元',
      room: '室',
      complainant: '投訴人',
      complainantPhone: '投訴人電話',
      complaintStatus: '投訴狀態',
      handler: '處理人',
      handlerPhone: '處理電話',
      operation: '操作',
      details: '詳情',
      flowChart: '流程圖',
      none: '無'
    },
    simplifyOwnerAccessContol: {
      objectType: '對象類型',
      objectName: '對象名稱',
      command: '指令',
      status: '狀態',
      remark: '說明',
      syncTime: '同步時間',
      operation: '操作',
      resync: '重新同步'
    },
    simplifyOwnerTransactionCar: {
      syncId: '同步ID',
      objectType: '對象類型',
      objectName: '對象名稱',
      command: '指令',
      status: '狀態',
      remark: '說明',
      syncTime: '同步時間',
      operation: '操作',
      resync: '重新同步'
    },
    simplifyShopsHireLog: {
      ownerName: '業主名稱',
      ownerPhone: '業主電話',
      startTime: '開始時間',
      endTime: '結束時間',
      createTime: '創建時間',
      operation: '操作',
      viewFee: '查看費用'
    }
  }
}